import React from 'react';
import styled from 'styled-components';
import CogniteLogo from 'components/CogniteLogo';
import Spinner from 'react-spinkit';

const Wrapper = styled.div`
  height: 100%;
  padding: 0;
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #005b8f;
`;

const LogoWrapper = styled.div`
  margin-left: auto;
  margin-right: auto;
  width: 25%;
`;

const Item = styled.div`
  width: 50%;
`;

const TextWrapper = styled.div`
  color: white;
  text-align: center;
  margin-top: 50px;
`;

const sentences = [
  'If you have any questions, you can get help by pressing the button in the bottom-right corner.',
  'You can customize your charts in many ways. Scroll or drag each individual y axis to position them exactly as you like.',
  'Upload your own image and overlay live sensor values from any asset and systems using our infographics.',
  'You can read metadata, hide series and set fixed y axis by clicking the Edit tag button in any chart.',
  "Remember to name your charts properly, so it's easy for other people to both find and use it.",
  "Remember to favorite the charts and infographics you're using often.",
  "Do you have any feedback for us? Please let us know, we're always just one click away. Look for us in the bottom right corner of this website.",
  "All charts and infographics are public by default. You can set them to private if you don't want to expose them.",
];

const sentence = sentences[Math.floor(Math.random() * sentences.length)];

const LoadingScreen = () => (
  <Wrapper>
    <Item>
      <LogoWrapper>
        <CogniteLogo />
      </LogoWrapper>
      <TextWrapper>
        <p style={{ fontSize: '1.5rem', fontWeight: 100 }}>{sentence}</p>
        <Spinner
          name="folding-cube"
          color="white"
          style={{
            height: '40px',
            width: '40px',
            marginLeft: 'auto',
            marginRight: 'auto',
            marginTop: '40px',
          }}
        />
      </TextWrapper>
    </Item>
  </Wrapper>
);

export default LoadingScreen;



// WEBPACK FOOTER //
// ./src/components/LoadingScreen/LoadingScreen.js